import { useState } from "react";

export default function InfiniteScrollWrapper({
  hasMore,
  next,
  className,
  children,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [actionTriggered, setActionTriggered] = useState(false);

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const handleScroll = debounce((e) => {
    if (!hasMore || isLoading || actionTriggered) return;
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const atBottom = scrollTop + clientHeight >= scrollHeight - 50;

    if (atBottom) {
      setIsLoading(true);
      try {
        setActionTriggered(true);
        next();
      } finally {
        setIsLoading(false);
        setActionTriggered(false);
      }
    }
  }, 300);

  return (
    <div
      className={className || "h-full max-h-screen overflow-y-scroll"}
      onScroll={(e) => {
        e.persist();
        handleScroll(e);
      }}
    >
      {children}
    </div>
  );
}
